import { useLoader } from "@react-three/fiber";
import { useRef, useMemo } from "react";
import * as THREE from "three";
import { CardProps } from "../utils";
import { asset } from "../../consts";

const CardColor = '#ffffff';

export default ({ id, position, rotation, isHovered, onMouseEnter, onMouseLeave, onClick }: CardProps) => {
  const meshRef = useRef<THREE.Mesh>(null);

  const s20024Texture = useLoader(THREE.TextureLoader, asset('/images/card/s20024-background.png'));
  const s20024Logo = useLoader(THREE.TextureLoader, asset('/images/card/s20024-logo.png'));
  
  const materials = useMemo(() => {
    return [
      new THREE.MeshBasicMaterial({ color: CardColor     }),
      new THREE.MeshBasicMaterial({ color: CardColor     }),
      new THREE.MeshBasicMaterial({ color: CardColor     }),
      new THREE.MeshBasicMaterial({ color: CardColor     }),
      new THREE.MeshBasicMaterial({ map:   s20024Texture }),
      new THREE.MeshBasicMaterial({ color: CardColor     }),
    ];
  }, [s20024Texture]);

  return (
    <mesh
      ref={meshRef}
      material={materials}
      castShadow
      position={position ?? [0, 0, 0]}
      rotation={rotation ?? [0, 0, 0]}
      onPointerEnter={(e) => {
        e.stopPropagation();
        onMouseEnter?.();
      }}
      onPointerLeave={(e) => {
        e.stopPropagation();
        onMouseLeave?.();
      }}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
    >
      <mesh position={[0, 10, 0]}><planeGeometry args={[0, 0]} /><meshBasicMaterial map={s20024Texture} transparent /></mesh>

      {/* 名刺サイズ: 91mm x 55mm : 1254px x 748px */}
      <boxGeometry args={[9.1, 5.5, 0.1]} />

      <group position={[0, 0, 0.051]} rotation={[0, 0, 0]}>
        <mesh position={[2.2, 0.7, 0.01]} scale={[1.5, 1.5, 1.5]} >
          <planeGeometry args={[1.1, 1.3]} />
          <meshBasicMaterial map={s20024Logo} transparent />
        </mesh>

        <mesh
          position={[-2.25, 0.025, 0.01]}
          onClick={(e) => {
            e.stopPropagation();
            window.open('mailto:s20024@std.it-college.ac.jp');
          }}
          onPointerEnter={(e) => {
            e.stopPropagation();
            document.body.style.cursor = 'pointer';
          }}
          onPointerLeave={(e) => {
            e.stopPropagation();
            document.body.style.cursor = 'default';
          }}
        >
          <planeGeometry args={[1.8, 0.15]} />
          <meshBasicMaterial transparent opacity={0} />
        </mesh>

        <mesh
          position={[-2.05, -1.5, 0.01]}
          onClick={(e) => {
            e.stopPropagation();
            window.open('https://github.com/s20024', '_blank');
          }}
          onPointerEnter={(e) => {
            e.stopPropagation();
            document.body.style.cursor = 'pointer';
          }}
          onPointerLeave={(e) => {
            e.stopPropagation();
            document.body.style.cursor = 'default';
          }}
        >
          <planeGeometry args={[1.675, 0.15]} />
          <meshBasicMaterial transparent opacity={0} />
        </mesh>
        <mesh
          position={[-1.775, -1.65, 0.01]}
          onClick={(e) => {
            e.stopPropagation();
            window.open('https://x.com/s20024itcollege', '_blank');
          }}
          onPointerEnter={(e) => {
            e.stopPropagation();
            document.body.style.cursor = 'pointer';
          }}
          onPointerLeave={(e) => {
            e.stopPropagation();
            document.body.style.cursor = 'default';
          }}
        >
          <planeGeometry args={[1.95, 0.15]} />
          <meshBasicMaterial transparent opacity={0} />
        </mesh>
        <mesh
          position={[-1.75, -1.825, 0.01]}
          onClick={(e) => {
            e.stopPropagation();
            window.open('https://portfolio.s20024.com', '_blank');
          }}
          onPointerEnter={(e) => {
            e.stopPropagation();
            document.body.style.cursor = 'pointer';
          }}
          onPointerLeave={(e) => {
            e.stopPropagation();
            document.body.style.cursor = 'default';
          }}
        >
          <planeGeometry args={[1.875, 0.15]} />
          <meshBasicMaterial transparent opacity={0} />
        </mesh>
      </group>
    </mesh>
  );
}
